import React from 'react';
import Hero from '../components/Hero';
import Hero2 from '../components/Hero2';
import About from '../components/About';
import Services from '../components/Services';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';

const Home = () => {
  return (
    <>
      <Hero />
      <Hero2/>
      <About />
      <Services />
      <FAQ />
      <Contact />
    </>
  );
};

export default Home;
